import type { TreeData } from './types';

type SearchTreeData = TreeData;

function isNodeMatching(child: TreeData, searchTerm: string): boolean {
    const { name } = child;
    return name.toLowerCase().includes(searchTerm);
}

function filterNode(result: SearchTreeData[], innerChild: TreeData, searchTerm: string): boolean {
    let found = false;
    let childClone: SearchTreeData = { ...innerChild, children: [] };

    const isNodeMatched = isNodeMatching(innerChild, searchTerm);
    if (isNodeMatched) {
        found = true;
    }

    const innerFound = filterNodes(childClone.children, innerChild, searchTerm);
    if (innerFound) {
        found = true;
        childClone = {
            ...innerChild,
            children: childClone.children
        };
    }
    if (isNodeMatched || innerFound) {
        result.push(childClone);
    }
    return found;
}

function filterNodes(result: SearchTreeData[], child: TreeData, searchTerm: string): boolean {
    let found = false;
    for (const innerChild of child.children) {
        found = filterNode(result, innerChild, searchTerm) || found;
    }
    return found;
}

export function filter(input: TreeData, searchTerm: string): SearchTreeData | undefined {
    const resultNodes: SearchTreeData[] = [];
    // Case insensitive search
    searchTerm = searchTerm.trim().toLowerCase().replace(/\s/g, '');
    if (!searchTerm) {
        //return input;
        return undefined;
    }
    // Apply search
    const found = filterNode(resultNodes, input, searchTerm);
    return found ? resultNodes[0] : undefined;
}
